import React, { useState, useEffect } from 'react';
import {
  Dialog,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Divider
} from '@mui/material';
import WeekViewCalendar from './WeekViewCalendar';

interface UnavailableBlockDialogProps {
  open: boolean;
  onClose: () => void;
  selectedDate: Date | null;
  practitionerId?: string;
  practitioners: any[];
  onBlockCreated: () => void;
}

const UnavailableBlockDialog: React.FC<UnavailableBlockDialogProps> = ({
  open,
  onClose,
  selectedDate,
  practitionerId: defaultPractitionerId,
  practitioners,
  onBlockCreated
}) => {
  const [selectedPractitionerId, setSelectedPractitionerId] = useState<string | undefined>(defaultPractitionerId);

  // Update selected practitioner when props change
  useEffect(() => {
    if (defaultPractitionerId) {
      setSelectedPractitionerId(defaultPractitionerId);
    } else if (practitioners.length > 0) {
      setSelectedPractitionerId(practitioners[0].id);
    }
  }, [defaultPractitionerId, practitioners]);

  // If the dialog is open, show the week view
  if (open) {
    // Log the practitioner info for debugging
    console.log("UnavailableBlockDialog - Practitioner Info:", {
      defaultPractitionerId,
      selectedPractitionerId,
      selectedDate,
      practitioners
    });
    
    // Find practitioner details if available
    const practitioner = practitioners.find(p => p.id === selectedPractitionerId);
    console.log("Selected practitioner:", practitioner);
    
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.15)',
            overflow: 'visible'
          }
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Manage Unavailable Time Blocks
            </Typography>
            <FormControl variant="outlined" sx={{ minWidth: 200 }}>
              <InputLabel id="practitioner-select-label">Practitioner</InputLabel>
              <Select
                labelId="practitioner-select-label"
                id="practitioner-select"
                value={selectedPractitionerId || ''}
                onChange={(e) => setSelectedPractitionerId(e.target.value)}
                label="Practitioner"
              >
                {practitioners.map((practitioner) => (
                  <MenuItem key={practitioner.id} value={practitioner.id}>
                    {practitioner.name || `${practitioner.first_name} ${practitioner.last_name}`.trim()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          
          <Divider sx={{ mb: 2 }} />
          
          <WeekViewCalendar 
            onClose={onClose}
            practitionerId={selectedPractitionerId}
            onBlocksCreated={onBlockCreated}
            initialDate={selectedDate || new Date()}
          />
        </Box>
      </Dialog>
    );
  }
  
  // If dialog is closed, render nothing
  return null;
};

export default UnavailableBlockDialog;